export function createBasketOrderPayload({ basketId, basketName, orderWindow }) {
  return {
    basket_id: basketId,
    name: basketName,
    order_id: orderWindow.id || orderWindow.oms_order_id || "",
    order_info: {
      exchange: orderWindow.exchange,
      instrument_token: orderWindow.instrument_token,
      client_id: localStorage.getItem("login_id") || "",
      oms_order_id: orderWindow.oms_order_id || "",
      exchange_order_id: orderWindow.exchange_order_id || "",
      order_type: orderWindow.order_type,
      price: orderWindow.price,
      quantity: orderWindow.quantity,
      disclosed_quantity: orderWindow.disclosed_quantity,
      validity: orderWindow.validity,
      product: orderWindow.product,
      trading_symbol: orderWindow.trading_symbol,
      order_side: orderWindow.order_side,
      user_order_id: String(orderWindow.user_order_id || "10002"),
      underlying_token: String(orderWindow.underlying_token || "0"),
      series: orderWindow.instrument_name || "",
      device: "WEB",
      trigger_price: orderWindow.trigger_price || 0,
      execution_type: String(orderWindow.execution_type).toUpperCase(),
      // Scrip info fields for margin calculation
      raw_board_lot_quantity: orderWindow.raw_board_lot_quantity || 1,
      trading_unit_factor: orderWindow.trading_unit_factor || 0,
      multiplier: orderWindow.multiplier || 1,
      lot_size: orderWindow.lot_size || 1,
    },
  };
}
